import bbox from '@turf/bbox';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import type { BBox, FeatureCollection, Polygon, MultiPolygon } from 'geojson';

import geoJsonData from '../../assets/shapefile-geojson.json';

let cachedBounds: BBox | null = null;

export function getShapefileBounds(): BBox {
  if (cachedBounds) return cachedBounds;

  cachedBounds = bbox(geoJsonData as unknown as FeatureCollection<Polygon | MultiPolygon>);

  return cachedBounds;
}

export function isLocationInBoundary(lat: number, lng: number): boolean {
  const featureCollection = geoJsonData as unknown as FeatureCollection<Polygon | MultiPolygon>;
  if (!featureCollection?.features) return false;

  const point = [lng, lat];

  for (const feature of featureCollection.features) {
    if (feature.geometry?.type === 'Polygon' || feature.geometry?.type === 'MultiPolygon') {
      if (booleanPointInPolygon(point, feature)) {
        return true;
      }
    }
  }

  return false;
}

export async function filterSuggestionsInBoundary(
  suggestions: google.maps.places.AutocompleteSuggestion[],
): Promise<google.maps.places.AutocompleteSuggestion[]> {
  const filteredSuggestions: google.maps.places.AutocompleteSuggestion[] = [];

  for (const suggestion of suggestions) {
    try {
      const place = suggestion.placePrediction?.toPlace();
      if (!place) continue;

      await place.fetchFields({ fields: ['location'] });

      const location = place.location;
      if (location) {
        const lat = location.lat();
        const lng = location.lng();

        if (isLocationInBoundary(lat, lng)) {
          filteredSuggestions.push(suggestion);
        }
      }
    } catch (error) {
      console.error('Error checking suggestion location:', error);
    }
  }

  return filteredSuggestions;
}
